import React from "react";
import {Autocomplete, TextField} from "@mui/material";
import {forms, objects, strings, validation} from "@atttomyx/shared-utils";

const LabeledPhoneForm = (props) => {
    const { options, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.label)
            && strings.isNotBlank(modified.value)
            && validation.validPhone(modified.value);

        onSync(modified);
    };

    return <div className="labeled-phone-form">
        <div className="field top-margin">
            <Autocomplete
                freeSolo={true}
                options={options}
                inputValue={forms.sanitizeValue(data.label)}
                value={null}
                isOptionEqualToValue={(option, value) => value && strings.equalsIgnoreCase(option, value)}
                renderInput={params =>
                    <TextField
                        required={true}
                        label="Label"
                        {...params}
                    />}
                onInputChange={(event, value, reason) => {
                    if (reason !== "reset") {
                        onChange("label", value);
                    }
                }}
                onChange={(event, value) => onChange("label", value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Phone"
                type="tel"
                value={forms.sanitizeValue(data.value)}
                error={!validation.validPhone(data.value)}
                onChange={(event) => onChange("value", event.target.value)}
            />
        </div>
    </div>
};

export default LabeledPhoneForm;
